import type { Team } from "./types";

export interface TeamMembershipRow {
  team_id: string;
  user_id: string;
}

export function groupTeamMemberIds(
  memberships: readonly TeamMembershipRow[]
): Record<string, string[]> {
  const memberIdsByTeam: Record<string, string[]> = {};

  for (const membership of memberships) {
    (memberIdsByTeam[membership.team_id] ??= []).push(membership.user_id);
  }

  return memberIdsByTeam;
}

export function replaceTeamMemberIdsForWorkspace(
  teams: readonly Team[],
  workspaceId: string,
  memberships: readonly TeamMembershipRow[]
): Team[] {
  const memberIdsByTeam = groupTeamMemberIds(memberships);

  return teams.map((team) =>
    team.workspaceId === workspaceId
      ? { ...team, memberIds: memberIdsByTeam[team.id] ?? [] }
      : team
  );
}

/**
 * Preserve an explicit team choice when it is still valid. Otherwise, land
 * the user in one of their own teams before falling back to workspace order.
 */
export function preferredTeamForUser(
  teams: readonly Team[],
  savedTeamId: string | null,
  currentUserId: string | null
): Team | null {
  const savedTeam = savedTeamId
    ? teams.find((team) => team.id === savedTeamId)
    : undefined;
  if (savedTeam) return savedTeam;

  const memberTeam = currentUserId
    ? teams.find((team) => team.memberIds.includes(currentUserId))
    : undefined;

  return memberTeam ?? teams[0] ?? null;
}
